
<b-container style="margin-top: 70px">
  <b-row>
    <b-col>
      <h1 class="mb-5 mt-3"><strong>Request a Quote</strong></h1>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <p class="mb-5">Please complete this form to have a copy of your quote request emailed to you and to our direct sale partner. Our sales representative will contact you shortly on available discounts and shipping options.</p>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <b-form class="mb-5">
        <b-container>
          <b-row>
            <b-col>
              <b-form-group
                  label="First Name"
                  label-for="first_name">
                <b-form-input size="sm"
                    id="first_name"
                    v-model="quote_request_form.first_name"
                    type="text"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  label="Last Name"
                  label-for="last_name">
                <b-form-input size="sm"
                    id="last_name"
                    v-model="quote_request_form.last_name"
                    type="text"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Email"
                  label-for="email">
                <b-form-input size="sm"
                    id="email"
                    v-model="quote_request_form.email"
                    type="email"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Re-enter Email"
                  label-for="email_confirmation">
                <b-form-input size="sm"
                    id="email_confirmation"
                    v-model="quote_request_form.email_confirmation"
                    type="email"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Phone"
                  label-for="phone">
                <b-form-input size="sm"
                    id="phone"
                    v-model="quote_request_form.phone"
                    type="phone"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="group_quantity_estimate" label="Quantity Estimate:" label-for="quantity">
                <b-form-select size="sm"
                    id="quantity"
                    v-model="quote_request_form.quantity"
                    :options="quantity_options"
                    required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Company"
                  label-for="company_name">
                <b-form-input size="sm"
                    id="first_name"
                    v-model="quote_request_form.company_name"
                    type="text"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="industry_form_group" label="Company Sector or Industry:" label-for="industry">
                <b-form-select size="sm"
                    id="industry"
                    v-model="quote_request_form.industry"
                    :options="industry_options"
                    required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Job Title"
                  label-for="job_title">
                <b-form-input size="sm"
                    id="job_title"
                    v-model="quote_request_form.job_title"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Address 1"
                  label-for="address_1">
                <b-form-input size="sm"
                    id="address_1"
                    v-model="quote_request_form.address_1"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Address 2"
                  label-for="address_2">
                <b-form-input size="sm"
                    id="address_2"
                    v-model="quote_request_form.address_2"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="City/Town"
                  label-for="city">
                <b-form-input size="sm"
                    id="address_2"
                    v-model="quote_request_form.city"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  label="State"
                  label-for="state">
                <b-form-input size="sm"
                    id="state"
                    v-model="quote_request_form.state"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  label="Zip"
                  label-for="zip">
                <b-form-input size="sm"
                    id="zip"
                    v-model="quote_request_form.zip"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Country"
                  label-for="country">
                <b-form-input size="sm"
                    id="country"
                    v-model="quote_request_form.country"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Comments"
                  label-for="comments">
                <b-form-textarea
                    id="comments"
                    v-model="quote_request_form.comments"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button type="submit" size="lg" variant="dark">Submit</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-col>
    <b-col>
      <b-container>
        <b-row>
          <b-col>
            <h2 class="m-3">Quote Summary</h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table-lite small
                          striped
                          stacked="lg"
                          class="mb-0"
                          :items="sorted_rows"
                          :fields="fields">
              <template v-slot:cell(part_number)="data">
                {{ data.item.code }}
              </template>
              <template v-slot:cell(part_description)="data">
                {{ data.item.name }}<br>
              </template>
              <template v-slot:cell(msrp_price)="data">
                {{ formatCurrency(data.item.msrp_price) }}
              </template>
            </b-table-lite>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button type="submit" size="lg" variant="dark" class="mt-3">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</b-container>
